import React from 'react'
import { capitalizeFirstLetter } from '../../../utils_v2'
import DeleteIcon from '@material-ui/icons/Delete';
import { Tooltip } from '@material-ui/core';

export default function DeRateTableHd(props) {
  return (
    <thead>
    <tr>
      { props.theads.map((title,index)=> <th className="sticky-background" key={index}><div style={{display:'flex'}}>{capitalizeFirstLetter(title)}{index ==0? '*':''}{index !==0 && props?.type =='view'? '%':''}{props?.type =='view'? null:(index === 0 || index == props.theads?.length -1)? null :
      <>
            % *
            <Tooltip title='Delete' placement='top' arrow>
            <DeleteIcon color='secondary' style={{ cursor: 'pointer', fontSize:'16px', marginLeft:'2px' }} onClick={()=>props?.onDerateDelete(index, title)} />
            </Tooltip>
      </>
            }</div></th>)
      }
    </tr>
  </thead>
  )
}
